import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
const OurMotto = () => {
  useEffect(() => {
    document.title = "Our Motto -  St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> About Us </li>
          <li> Our Motto </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Our Motto </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="quotes">
                <p>
                  <b> Learn today, Lead tomorrow.</b>
                </p>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="clearfix">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/motto.jpeg"
                      className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg"
                      alt=""
                    />

                    <div className="text-content">
                      <p>
                        Our aim in the pursuit of academic and professional
                        excellence is the total formation of the human person as
                        much for her/his own enrichment as for the service of
                        the society and the nation in the spirit of Christ.
                      </p>
                      <p>
                        We conscientize the youth to a sense of social justice.
                        We aim at creating a society which respects individual
                        dignity, challenges unjust social structures, nurtures
                        religious harmony and reaches out to the needy without
                        discrimination of any kind.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OurMotto;
